import { useSelector } from 'react-redux';
import { StyledReferrer } from './style';

const Referrer = () => {
  const referrer = useSelector((state) => state.referrer);

  if(referrer){
    return (
      <StyledReferrer>
        Você foi conviado pelo seu amigo <strong>{referrer.first_name}</strong>.
        Assine agora e ganhe um café secreto.
      </StyledReferrer>
    )
  }
  else return null;
}

export default Referrer;
